<template>
  <va-button
    medium
    inline
    color="#ff842b"
    icon="fa fa-chevron-left"
    class="ma-0"
    @click="goBack()">
    {{ $t('menu.back') }}
  </va-button>
</template>

<script>
export default {
  name: 'BackButton',
  props: {
    id: {
      type: String,
      required: false,
    },
  },

  methods: {
    goBack () {
      this.$router.go(-1, { params: { id: this.id } })
    },
  },
}
</script>
